<template>
    <div>
        <div v-if="!scraperRuns.length">
            Er zijn nog geen sraper runs uitgevoerd.
        </div>
        <table v-else class="w-full whitespace-no-wrap bg-white rounded shadow">
            <thead>
                <tr class="text-teal-800 font-bold">
                    <th class="px-4 py-4 text-left"><i class="fad fa-calendar-alt mr-1"></i>Called</th>
                    <th class="px-4 py-4">
                        <i class="fad fa-percentage mr-1"></i>
                    </th>
                    <th class="px-4 py-4">
                        <i class="fal fa-project-diagram mr-1"></i>
                    </th>
                    <th class="px-4 py-4">
                        <i class="fal fa-user-hard-hat mr-1"></i>
                    </th>
                    <!-- <th class="px-4 py-4">
                        <i class="fal fa-hourglass-half mr-1"></i>
                    </th> -->
                    <th class="px-4 py-4">
                        <i class="fad fa-check mr-1"></i>
                    </th>
                    <th class="px-4 py-4">
                        <i class="fal fa-exclamation-triangle mr-1"></i>
                    </th>
                    <th class="px-4 py-4">
                        <i class="fal fa-file-plus mr-1"></i>
                    </th>
                    <th class="px-4 py-4">
                        <i class="fal fa-file-edit mr-1"></i>
                    </th>
                    <th class="px-4 py-4">
                        <i class="fal fa-download mr-1"></i>
                    </th>
                    <th class="px-4 py-4">
                        <i class="fal fa-layer-plus mr-1"></i>
                    </th>
                    <th class="px-4 py-4 ">
                        <div class="flex justify-center items-top">
                            <i class="fad fa-leaf text-green-600"></i>
                            <i class="fa fa-plus text-xs ml-1 -mt-1"></i>
                        </div>
                    </th>

                    <th class="px-4 py-4 text-left"><i class="fal fa-stopwatch mr-1"></i></th>
                </tr>
            </thead>

            <tr
                v-for="(run, index) in scraperRuns"
                class="hover:text-teal-900 hover:bg-teal-300 focus-within:bg-teal-300 :text-teal-900"
                :class="!(index % 2) ? 'bg-teal-100' : ''"
            >
                <td class="px-3 py-4 border-t text-left">
                    {{ moment(run.created_at).format("DD-MM-YYYY") }}
                    <span class="text-xs">{{ moment(run.created_at).format("HH:mm") }}</span>
                </td>

                <td class="px-3 py-4 border-t text-left text-center text-sm">
                    {{ run.progress }}%
                    <div class="shadow w-full bg-teal-300">
                        <div class="bg-teal-400 text-xs leading-none py-1 text-center text-white" :style="{ width: run.progress + '%' }"></div>
                    </div>
                </td>

                <td class="px-3 py-4 border-t text-center">
                    <span v-if="run.scraper">{{ run.scraper.name }}</span>
                    <span v-else>Alle</span>
                </td>

                <td class="px-3 py-4 border-t text-center">
                    {{ run.jobs_dispatched | numberFormatNL }}
                </td>
                <!-- <td class="px-3 py-4 border-t text-center">
                    {{ run.jobs_remaining }}
                </td> -->
                <td class="px-3 py-4 border-t text-center">
                    {{ run.jobs_completed | numberFormatNL }}
                </td>
                <td class="px-3 py-4 border-t text-center">
                    {{ run.jobs_failed | numberFormatNL }}
                </td>
                <td class="px-3 py-4 border-t text-center">
                    {{ run.new_pages_found | numberFormatNL }}
                </td>
                <td class="px-3 py-4 border-t text-center">
                    {{ run.existing_pages_found | numberFormatNL }}
                </td>
                <td class="px-3 py-4 border-t text-center">
                    {{ run.pages_downloaded | numberFormatNL }}
                </td>
                <td class="px-3 py-4 border-t text-center">
                    {{ run.pages_parsed | numberFormatNL }}
                </td>
                <td class="px-3 py-4 border-t text-center">
                    {{ run.joboffers_created | numberFormatNL }}
                </td>
                <td class="px-3 py-4 border-t text-left">
                    <div v-if="moment.duration(moment(run.updated_at).diff(run.created_at)).minutes() == 0">
                        {{ moment.duration(moment(run.updated_at).diff(run.created_at)).seconds() }} sec
                    </div>
                    <div v-else="moment.duration(moment(run.updated_at).diff(run.created_at)).minutes() <= 60">
                        {{ moment.duration(moment(run.updated_at).diff(run.created_at)).minutes() }} min
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import _ from "lodash";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";

export default {
    mixins: [Helpers],

    components: {},

    props: {
        scraperRuns: Array
    },

    data() {
        return {};
    },

    methods: {}
};
</script>
